import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  SafeAreaView,
  ScrollView,
} from "react-native";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import FastImage from "../../../common/FastImage";
import CommonModal from "../../../commonComponents/commonModal";
import {
  chevron_right,
  contest_warning,
  left_double_arrow,
  participants,
  right_double_arrow,
} from "../../../utils/images";
import LiveRanks from "./LiveRanks";
import PrizeBreakUp from "./PrizeBreakUp";
import {
  hideLoader,
  showLoader,
} from "../../../commonComponents/Loader/loader.actions";
import { Network } from "../../../utils/network";
import { useDispatch } from "react-redux";
import { globalImport } from "../../../common/globalImports";
import DetailedPerformance from "./DetailedPerformance";
import BottomInfoContest from "./BottomInfoContest";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const LeaderBoard = ({ contestId, isClosedContest = false, isNewFormat }) => {
  const [isShowBreakUp, setIsShowBreakUp] = useState(false);
  const [leaderboardDetails, setLeaderboardDetails] = useState({
    liveRanks: [],
    prizePool: [],
  });
  const dispatch = useDispatch();

  useEffect(() => {
    getLeaderBoardDetail();
  }, []);

  const getLeaderBoardDetail = async () => {
    dispatch(showLoader());
    const res = await Network.getContestLeaderBoardDetails(contestId);
    if (res?.data?.success) {
      setLeaderboardDetails({
        liveRanks: res?.data?.leaderboard,
        prizePool: res?.data?.prize_pool_distribution,
        winningsPercentage: res?.data?.winnings_percentage,
        prizePoolPrice: res?.data?.prize_pool,
      });
    }
    dispatch(hideLoader());
  };

  const onShowBreakUp = () => {
    setIsShowBreakUp(!isShowBreakUp);
  };
  return (
    <View style={{ flexGrow: 1 }}>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          backgroundColor: Colors.bgWhite,
        }}
        showsVerticalScrollIndicator={false}
      >
        {!isNewFormat ? (
          <TouchableOpacity
            style={styles.prizePoolContainer}
            onPress={onShowBreakUp}
          >
            <FastImage
              style={{ width: 22, height: 22 }}
              source={right_double_arrow()}
            />

            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <FormTextLabel labelStyles={[styles.winningText]} label={"Winnings Break-up"} />
              <FastImage
                style={{ width: 16, height: 16 }}
                source={contest_warning()}
              />
            </View>
            <FastImage
              style={{ width: 22, height: 22 }}
              source={left_double_arrow()}
            />
          </TouchableOpacity>
        ) : null}
        <View style={{ flex: 1 }}>
          {!isNewFormat ? (
            <LiveRanks
              liveRanks={leaderboardDetails?.liveRanks}
              isClosedContest={isClosedContest}
            />
          ) : null}
          {isClosedContest && leaderboardDetails?.liveRanks?.length > 0 ? (
            <>
              {!isNewFormat ? (
                  <FormTextLabel
                    labelStyles={[styles.detailedPerformance]}
                    label={"Detailed Performance"}
                  />
              ) : null}
              <DetailedPerformance
                liveRanks={leaderboardDetails?.liveRanks}
                isNewFormat={isNewFormat}
              />
            </>
          ) : null}
        </View>
      </ScrollView>
      {isClosedContest && !isNewFormat ? (
        <BottomInfoContest isClosedContest={isClosedContest} />
      ) : null}

      <CommonModal
        onModalCallBack={onShowBreakUp}
        showModal={isShowBreakUp || false}
        customModalStyle={[globalStyle.modalView]}
      >
        <PrizeBreakUp
          prizePoolPrice={leaderboardDetails?.prizePoolPrice}
          prizePool={leaderboardDetails?.prizePool}
        />
      </CommonModal>
    </View>
  );
};

export default LeaderBoard;

const styles = StyleSheet.create({
  prizePoolContainer: {
    flexDirection: "row",
    borderRadius: 8,
    borderColor: Colors.borderColor,
    borderWidth: 0.75,
    backgroundColor: Colors.tradexBlue1,
    paddingVertical: 10,
    paddingHorizontal: 16,
    marginBottom: 15,
    justifyContent: "space-between",
  },
  containerSubtitle: {
    ...globalFontStyle.appFontSmallText,
    color: Color.black2,
    marginTop: 4,
  },
  containerTitle: {
    ...globalFontStyle.appFontSubText,
  },
  winningText: {
    ...globalFontStyle.appFontBody,
    color: Color.tradexBlue,
    alignSelf: "center",
    marginRight: 5,
  },
  modalStyle: {
    width: Width.width - 100,
    borderRadius: 12,
    padding: 0,
  },
  detailedPerformance: {
    ...globalFontStyle.appFontSubTextBold,
    marginBottom: 19,
  },
});
